'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = require('./utils/track');

var _track3 = _interopRequireDefault(_track2);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_STATUS, _propTypes3.default.string.isRequired), _propTypes);

function trackSubscriptionSale() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_SUBSCRIPTION_SALE + ' event');
    return (0, _track3.default)(_events.EVENT_SUBSCRIPTION_SALE, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_REVENUE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STATUS, traits[_traits.TRAIT_STATUS]), _track));
}

exports.default = trackSubscriptionSale;


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/~/rp-analytics/lib/trackSubscriptionSale.js
// module id = 1739
// module chunks = 0